import {
  FindOneSyncDocument,
  useRunRevEtlSyncNowMutation,
} from "@/apollo/types";
import { useToast } from "@/providers/ToastProvider";

export function useRunSyncNow(
  syncId: string,
  options?: {
    onCompleted?: () => void;
    onError?: (error: Error) => void;
  },
) {
  const toast = useToast();
  const [runSyncNow, { loading }] = useRunRevEtlSyncNowMutation({
    variables: {
      syncId: syncId,
    },
    refetchQueries: [
      {
        query: FindOneSyncDocument,
        variables: { syncId: syncId },
      },
    ],
    awaitRefetchQueries: true,
    onCompleted: options?.onCompleted,
    onError(error) {
      options?.onError?.(error);
      toast("Cannot run sync now", error.message, "error");
    },
  });

  return {
    runSyncNow: () => {
      if (!loading) {
        runSyncNow();
      }
    },
    isLoading: loading,
  };
}
